export default "__VITE_ASSET__BVztgIeL__"